// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-dumpsters-kpp-pages-js": () => import("./../../../src/templates/dumpsters-kpp-pages.js" /* webpackChunkName: "component---src-templates-dumpsters-kpp-pages-js" */)
}

